<template>
   <div class="footer wrap">
      <p>@2022 报名系统</p>
      <p>版权所有：国家市场监督管理总局专业技术人才开发中心</p>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>